<div class="appModalFooter__container">
  <ng-content></ng-content>
</div>
